/* eslint-disable jsx-a11y/anchor-has-content */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStyles } from 'theme/withStyles';
import buttonLinkStyles from 'styles/buttonLink';

const styles = ({ links, typography }) => ({
  detailHandle: {
    ...buttonLinkStyles(links),
    ...links.linkTertiary,
    color: links.link.color,
    fontFamily: typography.fontFamilies.secondary,
    lineHeight: '20px',
    position: 'absolute',
    right: 20,
    textDecoration: 'none',
    top: 11,
  },
});

const DetailHandle = ({ classes, collapsed, setCollapse }) => (
  /* eslint-disable-next-line jsx-a11y/anchor-is-valid */
  <button
    type="button"
    onClick={(e) => {
      e.preventDefault();
      setCollapse((c) => !c);
    }}
    className={classnames('buttonLink details-handle', { collapsed }, classes.detailHandle)}
  >
    {collapsed ? 'Details' : 'Close'}
  </button>
);

DetailHandle.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  collapsed: PropTypes.bool.isRequired,
  setCollapse: PropTypes.func.isRequired,
};

export default withStyles(styles)(DetailHandle);
